import { render } from "./PageMaisons.vue?vue&type=template&id=cf4e2a7e"
import script from "./PageMaisons.vue?vue&type=script&lang=js"
export * from "./PageMaisons.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/api-staging.champagne-booking.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__